import { h } from '@stencil/core';

export function renderStatsModal(component: any, onClose: () => void) {
  if (!component.currentStatistics) return null;
  const modalBg = getComputedStyle(document.documentElement).getPropertyValue('--vp-primary-bg').trim();

  const position = component.currentStatistics?.position ?? 'center';
  const contentAlignment = position === 'top-left' ? 'start' : position === 'top-right' ? 'end' : 'center';

  const closeModal = () => {
    onClose();
  };

  function hexToRgb(hex) {
    const r = parseInt(hex.slice(1, 3), 16);
    const g = parseInt(hex.slice(3, 5), 16);
    const b = parseInt(hex.slice(5, 7), 16);
    return `rgba(${r}, ${g}, ${b},0.55)`;
  }

  return (
    <div class="stats-overlay" style={{ justifyContent: contentAlignment }}>
      <div class="stats-modal" style={{ background: hexToRgb(modalBg) }}>
        <div class="stats-header">
          <h3>Statistics</h3>
          <button class="close-btn" onClick={closeModal}>
            ×
          </button>
        </div>
        <div class="stats-content" innerHTML={component.currentStatistics.htmlString}></div>
      </div>
    </div>
  );
}
